import {createSignal} from '@pexip/signal';

export const toggleWidgetSignal = createSignal<{widgetId: string}>();
